import { Music2, Heart, TrendingUp, ListMusic, Mic2, Disc3, Newspaper, Send, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const footerSections = [
  { name: "Notícias", icon: Newspaper },
  { name: "Shows", icon: Mic2 },
  { name: "Lançamentos", icon: Disc3 },
  { name: "Artistas", icon: Music2 },
];

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center mb-4" translate="no">
              <img
                src="/arrochaplay-logo.png?v=11"
                alt="ArrochaPlay"
                className="h-10 w-auto"
                draggable="false"
              />
            </Link>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-md">
              O maior portal de Arrocha do Brasil. 
              Rankings, playlists, notícias e tudo sobre seus artistas favoritos do Arrocha.
            </p>
            <div className="flex flex-wrap gap-2 mt-4">
              <a href="https://www.instagram.com/arrochaplayon" target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-600/20 to-pink-600/20 border border-pink-500/30 rounded-full text-pink-400 hover:text-pink-300 hover:border-pink-500/50 transition-all text-sm font-semibold"
                data-testid="instagram-footer-link">
                <Instagram size={18} />
                @arrochaplayon
              </a>
              <a href="https://www.facebook.com/share/18buTvPHdF/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600/20 to-sky-600/20 border border-blue-500/30 rounded-full text-blue-400 hover:text-blue-300 hover:border-blue-500/50 transition-all text-sm font-semibold"
                data-testid="facebook-footer-link">
                <Facebook size={18} />
                Facebook
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Explorar</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/ranking" className="text-zinc-500 hover:text-[#FF007F] text-sm transition-colors flex items-center gap-2">
                  <TrendingUp size={14} /> Top 10
                </Link>
              </li>
              <li>
                <Link to="/playlists" className="text-zinc-500 hover:text-[#FF007F] text-sm transition-colors flex items-center gap-2">
                  <ListMusic size={14} /> Playlists
                </Link>
              </li>
              {footerSections.map(({ name, icon: Icon }) => (
                <li key={name}>
                  <Link
                    to={`/categoria/${encodeURIComponent(name)}`}
                    className="text-zinc-500 hover:text-[#FF007F] text-sm transition-colors flex items-center gap-2"
                  >
                    <Icon size={14} /> {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-bold text-white mb-4">Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-zinc-500 hover:text-[#FF007F] text-sm transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/divulgue" className="text-zinc-500 hover:text-[#FF007F] text-sm transition-colors flex items-center gap-2">
                  <Send size={14} /> Divulgue sua Banda
                </Link>
              </li>
              <li>
                <a href="https://suamusica.com.br" target="_blank" rel="noopener noreferrer" className="text-zinc-500 hover:text-green-400 text-sm transition-colors flex items-center gap-2">
                  <Music2 size={14} /> Sua Música
                </a>
              </li>
              <li>
                <Link to="/admin" className="text-zinc-500 hover:text-[#FF007F] text-sm transition-colors">
                  Área Administrativa
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-sm flex items-center gap-1">
            Feito com <Heart className="w-4 h-4 text-[#FF007F]" /> na Bahia
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.instagram.com/arrochaplayon" target="_blank" rel="noopener noreferrer"
              className="text-zinc-600 hover:text-pink-400 text-sm flex items-center gap-1 transition-colors">
              <Instagram size={14} /> Instagram
            </a>
            <a href="https://www.facebook.com/share/18buTvPHdF/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"
              className="text-zinc-600 hover:text-blue-400 text-sm flex items-center gap-1 transition-colors">
              <Facebook size={14} /> Facebook
            </a>
          </div>
          <p className="text-zinc-600 text-sm">
            &copy; {new Date().getFullYear()} arrochaplay. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
